function initCollectionFilter() {
  document.addEventListener("DOMContentLoaded", () => {
    const filterContainer = document.querySelector(
      ".js-product-filter-sidebar",
    );
    const productsContainer = document.querySelector(".collection-products");

    if (!filterContainer || !productsContainer) return;

    let filterForm = filterContainer.querySelector("form");

    // --- Utility: fetch and replace ---
    async function updateCollection(url, pushState = true) {
      try {
        const res = await fetch(url, { headers: { Accept: "text/html" } });
        const html = await res.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        // Replace products
        const updatedProducts = doc.querySelector(".collection-products");
        if (updatedProducts)
          productsContainer.innerHTML = updatedProducts.innerHTML;

        // Preserve open <details> before replacing form
        const openDetails = Array.from(
          filterForm.querySelectorAll("details[open]"),
        ).map(
          (d) =>
            d.dataset.filterGroup ||
            d.querySelector("summary").textContent.trim(),
        );

        // Replace filter form entirely so enabled/disabled is correct
        const updatedForm = doc.querySelector(
          ".js-product-filter-sidebar form",
        );
        if (updatedForm) {
          filterContainer.innerHTML = "";
          filterContainer.appendChild(updatedForm);
          filterForm = updatedForm;
          bindInputListeners(); // rebind change listeners

          // Restore open <details>
          filterForm.querySelectorAll("details").forEach((d) => {
            const identifier =
              d.dataset.filterGroup ||
              d.querySelector("summary").textContent.trim();
            if (openDetails.includes(identifier)) d.open = true;
          });
        }

        // Replace running tags
        const tagsContainer = document.querySelector(".js-product-filter-tags");
        const updatedTags = doc.querySelector(".js-product-filter-tags");
        if (tagsContainer && updatedTags)
          tagsContainer.innerHTML = updatedTags.innerHTML;

        // Update URL correctly
        if (pushState) window.history.pushState({}, "", url);

        // Dispatch event for other JS to re-init
        document.dispatchEvent(
          new CustomEvent("collection:updated", { detail: { url } }),
        );
      } catch (err) {
        console.error("Failed to update collection:", err);
      }
    }

    // --- Handle form submit ---
    filterForm.addEventListener("submit", (e) => {
      e.preventDefault();
      const url =
        window.location.pathname +
        "?" +
        new URLSearchParams(new FormData(filterForm));
      updateCollection(url);
    });

    // --- Live filter on input change ---
    function bindInputListeners() {
      filterForm
        .querySelectorAll('input[type="checkbox"], input[type="number"]')
        .forEach((input) => {
          input.removeEventListener("change", handleInputChange);
          input.addEventListener("change", handleInputChange);
        });
    }

    function handleInputChange() {
      const url =
        window.location.pathname +
        "?" +
        new URLSearchParams(new FormData(filterForm));
      updateCollection(url);
    }

    bindInputListeners();

    // --- Pagination delegation ---
    productsContainer.addEventListener("click", (e) => {
      const link = e.target.closest(".pagination a");
      if (!link) return;
      e.preventDefault();
      updateCollection(link.href);
    });

    // --- Back/forward support ---
    window.addEventListener("popstate", () => {
      updateCollection(window.location.href, false);
    });
  });
}

initCollectionFilter();

export { initCollectionFilter };
